import { AxiosError } from "axios";
import { apiMe } from "@/common/services";
import type { IOperation } from "@/common/api";
import { IErrorData, IUserSettings } from "@/common/api/services/types";
import { showNotification } from "@/common/utils/showNotification";
import { useUpdateUserData } from "@/common/hooks/useUpdateUserData";

export const useUserSettingsHandlers = () => {
  const { updateUserData: updateUserProfileData } = useUpdateUserData<IOperation[]>({
    updateRequest: (params) => apiMe.updateProfileInfo(params),
  });

  const { updateUserData: updateUserSettingsData } = useUpdateUserData<IUserSettings>({
    updateRequest: (params) => apiMe.updateUserSettings(params),
  });

  const handleApiError = (e: unknown) => {
    const err = e as AxiosError<IErrorData>;
    const message = err.response?.data?.error?.message ||
      "An error occurred, please try again later";

    showNotification({
      title: message,
      variant: "error",
    });
  };

  const handleSuccessNotification = () => {
    showNotification({
      title: "Successfully updated!",
      variant: "success",
    });
  };

  const updateUserProfile = async (params: IOperation[]) => {
    try {
      await updateUserProfileData(params);
      handleSuccessNotification();
    } catch (e) {
      handleApiError(e);
    }
  };

  const updateUserSettings = async (params: IUserSettings) => {
    try {
      await updateUserSettingsData(params);
      handleSuccessNotification();
    } catch (e) {
      handleApiError(e);
    }
  };

  return {
    updateUserSettings,
    updateUserProfile
  };
};
